export default __webpack_public_path__ + "static/media/Blade of Khan.382b2a2d.jpg";